import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./slices/auth.slice";
import { userApi } from "./api/user.api";
import { projectTypesApi } from "./api/project-types.api";
import { optionsApi } from "./api/options.api";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [userApi.reducerPath]: userApi.reducer,
    [projectTypesApi.reducerPath]: projectTypesApi.reducer,
    [optionsApi.reducerPath]: optionsApi.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(
      userApi.middleware,
      projectTypesApi.middleware,
      optionsApi.middleware,
    );
  },
});

export type RulesEngineStore = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
